import React from 'react';
import { useSelector } from 'react-redux';

const UserSelect = ({ value, onChange, className = '', disabled = false }) => {
    const users = useSelector(state => state.user?.users || []);
    const loading = useSelector(state => state.user?.loading || false);

    return (
        <select
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            className={className || 'border p-2 rounded w-full'}
            disabled={disabled || loading}
        >
            <option value="">Select User</option>
            {users.map(user => (
                <option key={user.id} value={user.id}>
                    {user.username || user.email || user.firstName + ' ' + user.lastName || `User ${user.id}`}
                </option>
            ))}
        </select>
    );
};

export default UserSelect;
